// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__GdURA","header":"PatientBlock_header__rkTRJ","label":"PatientBlock_label__2ZAk7","option":"PatientBlock_option__3M-6Y"};